import { createActions, createReducer } from 'reduxsauce';

// Define Action
const { Types, Creators }  = createActions({
  showDialog: ['msg'],
  showToast: ['msg'],
  redirect: ['url']
});

export const Creator = Creators;
export const Type = Types;

// Define Initial State
const INITIAL_STATE = {
  errMsg: '',
  toast: false,
  dialog: false
}

// Define Reducer
export default createReducer(INITIAL_STATE, {

});
